interface DigitalProductCategoriesProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const DigitalProductCategories = ({ activeTab, onTabChange }: DigitalProductCategoriesProps) => {
  const tabs = [
    { id: 'all', label: "All Products" },
    { id: 'digital', label: 'Digital Products' },
    { id: 'service', label: 'Services' },
    { id: 'featured', label: 'Featured Deals' },
  ];

  const handleTabClick = (tabId: string) => {
    onTabChange(tabId);
  };

  return (
    <>
      <div className="w-100 bg-gray-100 border-bottom">
        <div className="justify-content-start container text-start">
          <ul className="nav nav-pills p-1 mt-2 mb-1 bg-gray-100" id="pills-tab" role="tablist">
            {tabs.map((tab) => (
              <li key={tab.id} className="nav-item" role="presentation">
                <button
                  className={`nav-link fw-bold border-radius-lg me-2 ${activeTab === tab.id ? 'active' : ''}`}
                  id={`pills-${tab.id}-tab`}
                  role="tab"
                  aria-controls={`pills-${tab.id}`}
                  aria-selected={activeTab === tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  type="button"
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default DigitalProductCategories;
